var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateOrder',{attrs:{"orderDetail":_vm.orderDetail},on:{"saveOrder":_vm.saveOrder,"cancelCreate":_vm.cancelCreate}})
}
var staticRenderFns = []

export { render, staticRenderFns }